import api from "@/http/api";
// import Rsa from '@/utils/rsa.js';
import router from "@/router";
let lastTime = new Date().getTime();
let currentTime = new Date().getTime();
let timeOut = 15 * 60 * 1000; //设置超时时间: 5分钟
window.onload = function() {
  window.document.onmousedown = function() {
    let token = sessionStorage.getItem("token");
    // 保存最新的操作时间到storage中
    if (token) {
      sessionStorage.setItem("lastTime", new Date().getTime());
    }
  };
};
/**
 *
 * @returns asdf
 */
async function checkTimeout() {
  let token = sessionStorage.getItem("token");
  let timestamp = sessionStorage.getItem("timestamp");

  if (!token) return;
  //更新当前时间
  currentTime = new Date().getTime();
  lastTime = sessionStorage.getItem("lastTime");
  //判断是否超时
  if (currentTime - lastTime > timeOut) {
    // 清除storage的数据(登陆信息和token)
    sessionStorage.clear();
    sessionStorage.setItem("lastTime", new Date().getTime());
    router.push("/login");
    // 移除cookie
  }
}

export default function() {
  /* 定时器 间隔10秒检测是否长时间未操作页面 */
  window.setInterval(checkTimeout, 60e3);
}



// WEBPACK FOOTER //
// ./src/utils/checkTimerOut.js